import { IconButtonProps, IconButton } from '@mui/material'
import React from 'react'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'

const TableButtonShow: React.FC<IconButtonProps> = (props) => {
    return (
        <IconButton
            {...props}
            style={{
                border: '1px solid',
                borderRadius: '10%',
                maxWidth: '28px',
                maxHeight: '28px',
                minWidth: '28px',
                minHeight: '28px',
                width: '28px',
                height: '28px',
            }}
            color='primary'
        >
            <RemoveRedEyeOutlinedIcon style={{ width: '16px', height: '16px' }} />
        </IconButton>
    )
}

export default TableButtonShow
